module.exports = __webpack_public_path__ + "static/media/Banner.cd363d80.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/liveClasses/Banner.webp
// module id = 302
// module chunks = 4 6 7